(() => {
  if (window.cutepidProductCardPreviewInitialized) return;
  window.cutepidProductCardPreviewInitialized = true;

  const holdDelay = 275;
  const moveThreshold = 10;
  let press = null;

  const findPreview = (event) => {
    const wrapper = event.target.closest?.('.product-card-wrapper');
    const preview = wrapper?.querySelector('[data-product-card-preview]');
    if (!preview) return null;

    const bounds = preview.getBoundingClientRect();
    const inside =
      event.clientX >= bounds.left &&
      event.clientX <= bounds.right &&
      event.clientY >= bounds.top &&
      event.clientY <= bounds.bottom;

    return inside ? preview : null;
  };

  const reset = () => {
    if (!press) return;
    window.clearTimeout(press.timer);
    press.preview.classList.remove('is-previewing');
    press = null;
  };

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (event.pointerType === 'mouse' || event.button !== 0 || press) return;

      const preview = findPreview(event);
      if (!preview) return;

      press = {
        pointerId: event.pointerId,
        preview,
        startX: event.clientX,
        startY: event.clientY,
        active: false,
        timer: window.setTimeout(() => {
          if (!press || press.pointerId !== event.pointerId) return;
          press.active = true;
          press.preview.classList.add('is-previewing');
        }, holdDelay),
      };
    },
    { passive: true }
  );

  document.addEventListener(
    'pointermove',
    (event) => {
      if (!press || event.pointerId !== press.pointerId) return;
      const distance = Math.hypot(event.clientX - press.startX, event.clientY - press.startY);
      if (distance > moveThreshold) reset();
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerup',
    (event) => {
      if (!press || event.pointerId !== press.pointerId) return;
      const preview = press.preview;
      const held = press.active;
      reset();

      if (held) {
        preview.dataset.suppressPreviewClick = 'true';
        window.setTimeout(() => delete preview.dataset.suppressPreviewClick, 400);
      }
    },
    { passive: true }
  );

  document.addEventListener('pointercancel', reset, { passive: true });
  window.addEventListener('scroll', reset, { passive: true, capture: true });

  document.addEventListener(
    'click',
    (event) => {
      const wrapper = event.target.closest?.('.product-card-wrapper');
      const preview = wrapper?.querySelector('[data-suppress-preview-click="true"]');
      if (!preview) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      delete preview.dataset.suppressPreviewClick;
    },
    true
  );

  document.addEventListener('contextmenu', (event) => {
    if (press?.active && press.preview.closest('.product-card-wrapper')?.contains(event.target)) {
      event.preventDefault();
    }
  });
})();

